<template>
    <div class="home">
        <template v-if="mode == 1">
            <div class="content">
                <div class="banner">
                    <div class="slogan">
                        <img src="../assets/home/title.png" />
                    </div>
                    <div class="card-wrap">
                        <div class="card">
                            <img
                                class="card-pic"
                                :src="picUrl + productInfo.logoUrl"
                            />
                            <img
                                class="card-icon"
                                src="../assets/home/huangguan.png"
                            />
                        </div>
                    </div>
                    <div class="card-inner">
                        <img src="../assets/home/cardWrap.png" />
                    </div>
                </div>
                <!-- 套餐 -->
                <div class="setMeal">
                    <div
                        class="list"
                        v-for="item in setMeal"
                        v-bind:key="item.pic"
                    >
                        <div class="Meal-title">
                            <p class="title van-ellipsis">{{ item.title }}</p>
                            <p class="subTitle van-ellipsis">
                                {{ item.subTitle }}
                            </p>
                        </div>
                        <div
                            class="Meal-price"
                            :style="{
                                'background-image': 'url(' + item.pic + ')',
                            }"
                        >
                            <div class="type">{{ item.type }}</div>
                            <div class="price">{{ item.price }}</div>
                        </div>
                    </div>
                </div>
                <div class="service-list">
                    <div class="title">优惠9折起</div>
                    <div class="tool">
                        <div class="list">
                            <img class="pic" src="../assets/home/tool00.png" />
                            <p>门票</p>
                        </div>
                        <div class="list">
                            <img class="pic" src="../assets/home/tool01.png" />
                            <p>机票</p>
                        </div>
                        <div class="list">
                            <img class="pic" src="../assets/home/tool02.png" />
                            <p>酒店</p>
                        </div>
                        <div class="list">
                            <img class="pic" src="../assets/home/tool03.png" />
                            <p>加油</p>
                        </div>
                    </div>
                </div>
                <!-- 热门景区 -->
                <div class="hotScenic">
                    <div class="hotTitle">
                        <span class="txt">精选推荐</span>
                    </div>
                    <div class="hotContent">
                        <!-- 热门景区一 -->
                        <div class="scenicTop" v-if="scnicDataFrist.length">
                            <div class="first">
                                <div
                                    class="pic"
                                    :style="{
                                        'background-image':
                                            'url(' +
                                            picUrl +
                                            scnicDataFrist[0]['scenicUrl'] +
                                            ')',
                                    }"
                                >
                                    <div class="tag"><span>精选</span></div>
                                </div>
                                <div class="text">
                                    <span class="name van-ellipsis">{{
                                        scnicDataFrist[0].scenicName
                                    }}</span>
                                    <span class="address-distance">
                                        <span class="van-ellipsis">{{
                                            scnicDataFrist[0].address
                                        }}</span>
                                        <span
                                            class="distance"
                                            v-if="scnicDataFrist[0].distance"
                                            >{{
                                                distance(
                                                    scnicDataFrist[0].distance
                                                )
                                            }}</span
                                        >
                                    </span>
                                </div>
                            </div>
                            <div class="sceond-thire">
                                <div class="sceond">
                                    <div
                                        class="pic"
                                        :style="{
                                            'background-image':
                                                'url(' +
                                                picUrl +
                                                scnicDataFrist[1]['scenicUrl'] +
                                                ')',
                                        }"
                                    >
                                        <div class="tag"><span>精选</span></div>
                                    </div>
                                    <div class="text">
                                        <span class="name van-ellipsis">{{
                                            scnicDataFrist[1].scenicName
                                        }}</span>
                                        <span class="address-distance">
                                            <span class="van-ellipsis">{{
                                                scnicDataFrist[1].address
                                            }}</span>
                                            <span
                                                class="distance"
                                                v-if="
                                                    scnicDataFrist[1].distance
                                                "
                                                >{{
                                                    distance(
                                                        scnicDataFrist[1]
                                                            .distance
                                                    )
                                                }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                                <div class="thire">
                                    <div
                                        class="pic"
                                        :style="{
                                            'background-image':
                                                'url(' +
                                                picUrl +
                                                scnicDataFrist[2]['scenicUrl'] +
                                                ')',
                                        }"
                                    >
                                        <div class="tag"><span>精选</span></div>
                                    </div>
                                    <div class="text">
                                        <span class="name van-ellipsis">{{
                                            scnicDataFrist[2].scenicName
                                        }}</span>
                                        <span class="address-distance">
                                            <span class="van-ellipsis">{{
                                                scnicDataFrist[2].address
                                            }}</span>
                                            <span
                                                class="distance"
                                                v-if="
                                                    scnicDataFrist[2].distance
                                                "
                                                >{{
                                                    distance(
                                                        scnicDataFrist[2]
                                                            .distance
                                                    )
                                                }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 热门景区二 -->
                        <div class="hotTitle">
                            <span class="txt">热门景区</span>
                        </div>
                        <div
                            class="scenicList"
                            v-for="item in scnicDataSceond"
                            v-bind:key="item.scenicName"
                        >
                            <div
                                class="pic"
                                :style="{
                                    'background-image':
                                        'url(' +
                                        picUrl +
                                        item['scenicUrl'] +
                                        ')',
                                }"
                            >
                                <div class="tag">
                                    <span>{{ item.scenicType }}</span>
                                </div>
                            </div>
                            <div class="text">
                                <span class="name van-ellipsis">{{
                                    item.scenicName
                                }}</span>
                                <p class="address nowrap-double">
                                    {{ item.address }}
                                </p>
                                <p class="distance" v-if="item.distance">
                                    {{ distance(item.distance) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <img class="foot-logo" src="../assets/home/LOGO.png" alt />
            </div>
            <div class="footer">
                <div class="payGo" @click="payGo">
                    <div class="name-price">
                        <span class="name">
                            {{ productInfo.name }}
                            <template v-if="platformSwitch && price"
                                >（官方平台购卡）</template
                            >
                        </span>
                        <span v-if="productInfo.price" class="price">
                            <span class="icon">¥</span>
                            {{ productInfo.price }}
                        </span>
                    </div>
                    <div class="pay">立即购买</div>
                </div>
            </div>
        </template>
        <template v-if="mode == 2">
            <skinPackageOne
                :picUrl="picUrl"
                :price="price"
                :scnicDataFrist="scnicDataFrist"
                :scnicDataSceond="scnicDataSceond"
                :setMeal="setMeal"
                :productInfo="productInfo"
                :platformSwitch="platformSwitch"
                v-on:paylistener="payGo"
            ></skinPackageOne>
        </template>
        <template v-if="mode == 3">
            <skinPackageTwe
                :picUrl="picUrl"
                :price="price"
                :scnicDataFrist="scnicDataFrist"
                :scnicDataSceond="scnicDataSceond"
                :setMeal="setMeal"
                :productInfo="productInfo"
                :platformSwitch="platformSwitch"
                v-on:paylistener="payGo"
            ></skinPackageTwe>
        </template>
        <template v-if="mode == 4">
            <skinPackageThree
                :picUrl="picUrl"
                :price="price"
                :scnicDataFrist="scnicDataFrist"
                :scnicDataSceond="scnicDataSceond"
                :setMeal="setMeal"
                :productInfo="productInfo"
                :platformSwitch="platformSwitch"
                v-on:paylistener="payGo"
            ></skinPackageThree>
        </template>
        <template v-if="mode == 5">
            <skinPackageFour
                :picUrl="picUrl"
                :price="price"
                :scnicDataFrist="scnicDataFrist"
                :scnicDataSceond="scnicDataSceond"
                :setMeal="setMeal"
                :productInfo="productInfo"
                :platformSwitch="platformSwitch"
                v-on:paylistener="payGo"
            ></skinPackageFour>
        </template>
		<!-- 2022-08-10 H5新的购卡 -->
		<template v-if="mode == 6">
            <skinPackageFive
                :picUrl="picUrl"
                :price="price"
                :scnicDataFrist="scnicDataFrist"
                :scnicDataSceond="scnicDataSceond"
                :setMeal="setMeal"
                :productInfo="productInfo"
                :platformSwitch="platformSwitch"
                v-on:paylistener="payGo"
            ></skinPackageFive>
        </template>
    </div>
</template>

<script>
var md5Code = require("../utils/md5.js");
import skinPackageOne from "../components/skinPackageOne.vue";
import skinPackageTwe from "../components/skinPackageTwe.vue";
import skinPackageThree from "../components/skinPackageThree.vue";
import skinPackageFour from "../components/skinPackageFour.vue";
import skinPackageFive from "../components/skinPackageFive.vue";
import { Dialog, Toast } from "vant";
import request from "../utils/request.js";
import qs from "qs";
import md5 from "js-md5";
import Cookies from "js-cookie";

import { checkUserAgent } from "@/utils/checkUserAgent";

import setMeal00 from "./../assets/home/jingqu.png";
import setMeal01 from "./../assets/home/jiayou.png";

export default {
    name: "Home",
    components: {
        skinPackageOne,
        skinPackageTwe,
        skinPackageThree,
        skinPackageFour,
		skinPackageFive
    },
    mixins: [checkUserAgent],
    data() {
        return {
            mode: "",
            picUrl: "",
            themePicUrl: "",
            price: "",
            scnicDataFrist: [],
            scnicDataSceond: [],
            setMeal: [],
            longitude: "",
            latitude: "",
            channelId: "",
            productId: "",
            platformSwitch: false,
            province: "",
            productInfo: {
                logoUrl: "",
                name: "",
                price: "",
            },
            userAgent: "",
        };
    },
    created() {
        this.init();
    },

    methods: {
        // 页面初始化
        init() {
            this.checkUserAgent({
                success: (res) => {
                    this.userAgent = res; // 环境
                    console.log(`环境：${res}，首页`);
                    this.mode = this.$route.query.mode || "1"; // 模式获取
					console.log(this.mode)
                    if (this.mode == 6) { document.title = '中旅随行' } // mode==6,title文案修改
                    let channelId = this.$route.query.channelid; // 代理商ID
                    if (!channelId) {
                        return this.$toast("链接或二维码异常");
                    }
                    this.channelId = channelId;
                    this.productId = this.$route.query.productId; // 卡片ID
                    // 小程序内嵌
                    if (res === "miniprogram") {
                        this.appId = this.$route.query.appId; // 小程序APPID
                        this.openId = this.$route.query.openId; // openid
                        Cookies.set("appId", this.$route.query.appId);
                        Cookies.set("openId", this.$route.query.openId);
                    }
                    // 微信打开
                    // if (res === 'wechat') { }
                    // 浏览器打开
                    // if (res === 'h5') {}
                    if (this.productId == 56) {
                        this.setMeal = [
                            {
                                pic: setMeal00,
                                title: "景区门票",
                                subTitle: "4000+景区门票低至2折起",
                                price: "2000元起",
                                type: "节省",
                            },
                            {
                                pic: setMeal01,
                                title: "车主加油",
                                subTitle: "10000+家油站加油9折起",
                                price: "2000元起",
                                type: "节省",
                            },
                        ];
                    } else {
                        this.setMeal = [
                            {
                                pic: setMeal00,
                                title: "景区门票",
                                subTitle: "2000+景区免费畅游",
                                price: "19800元",
                                type: "价值",
                            },
                            {
                                pic: setMeal01,
                                title: "车主加油",
                                subTitle: "10000+家油站加油9折起",
                                price: "2000元起",
                                type: "节省",
                            },
                        ];
                    }
                    //获取产品详情
                    this.getProductDetail();
                    // 定位且获取景区列表
                    this.getLocation();
                    // 获取图片前缀
                    this.picUrlQuery();
                    // 获取查询渠道商
                    this.priceQuery();
                },
            });
        },
        // 圖片前綴
        picUrlQuery() {
            const that = this;
            request({
                url: "/tour-product/imge/getUrl",
                method: "post",
            })
                .then(function (res) {
                    if (res.data.code != "200") {
                        throw res.data.msg;
                    }
                    if (res.data.code == "200") {
                        that.picUrl = res.data.data;
                        that.themePicUrl =
                            res.data.data + process.env.VUE_APP_PIC_URL;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        //获取产品详情
        getProductDetail() {
            const that = this;
            try {
                const appId = 1;
                const key = 1112;
                let data = {
                    productId: this.productId,
                };
                // 签名生成
                let sign = "appId=" + appId;
                if (data && Object.keys(data).length > 0) {
                    let newKeys = Object.keys(data).sort();
                    newKeys.forEach((key) => {
                        sign += "&" + key + "=" + data[key];
                    });
                }
                sign += key;
                sign = md5Code.md5(sign).toUpperCase();
                data.sign = sign;
                data.appId = appId;
                request({
                    url: "/tour-product/sysProduct/queryProductDetail",
                    method: "post",
                    params: data,
                })
                    .then(function (res) {
                        if (res.data.code == 200) {
                            const data = {
                                logoUrl: res.data.data.logoUrl,
                                name: res.data.data.name,
                                price: res.data.data.price,
                                type: res.data.data.type,
                            };
                            that.productInfo = data;
                            console.log(data);
                            Cookies.set("productInfo", JSON.stringify(data));
                            Cookies.set("productType", res.data.data.type);
                        } else {
                            that.$toast(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        that.$toast(err);
                    });
            } catch (e) {
                console.log(e);
            }
        },
        // 激活卡跳转
        payGo() {
            if (!this.productInfo.price || !this.channelId) {
                return this.$toast("链接或二维码异常");
            }
            // 微信客户端
            if (this.userAgent === "wechat") {
                console.log(
                    `${process.env.VUE_APP_BASE_API}/tour-product/weixin/auth`
                );
                window.location.href = `${process.env.VUE_APP_BASE_API}/tour-product/weixin/auth`; //正式库
            }
            // 小程序
            if (this.userAgent === "miniprogram") {
                this.$router.push({
                    path: `./cardactive?openId=${this.openId}&appId=${this.appId}`,
                });
            }
            // 浏览器
            if (this.userAgent === "h5") {
                this.$router.push({
                    path: `./cardactive`,
                });
            }
        },
        // 获取经纬度
        getLocation() {
            const that = this;
            const map = new AMap.Map("container", {
                resizeEnable: true,
            });
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                });
                map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status == "complete") {
                        onComplete(result);
                    } else {
                        onError(result);
                    }
                });
            });
            //解析定位结果
            function onComplete(data) {
                that.longitude = data.position.lng;
                that.latitude = data.position.lat;
                // 获取所在省份
                const appId = 1;
                const key = 1112;
                let cc = {
                    latitude: that.latitude,
                    longitude: that.longitude,
                };
                let sortstr = "appId=" + appId;
                let keyArr = Object.keys(cc);
                keyArr.forEach((item) => {
                    sortstr += "&" + item + "=" + cc[item];
                });
                sortstr += key;
                const sign = md5(sortstr).toUpperCase();

                let reqData = Object.assign({ sign: sign, appId: appId }, cc);
                reqData = qs.stringify(reqData);
                request({
                    url: "/tour-product/wxscenic/getLocationProvince",
                    method: "post",
                    data: reqData,
                })
                    .then((res) => {
                        if (res.data.code != "200") {
                            throw res.data.msg;
                        }
                        if (res.data.code == "200") {
                            that.province = res.data.data.province;
                            that.scnicQuery();
                        }
                    })
                    .catch(() => {
                        that.scnicQuery();
                    });
            }
            //解析定位错误信息
            function onError() {
                console.log("定位失败");
                that.scnicQuery();
            }
        },
        // 景区列表
        scnicQuery() {
            const that = this;
            try {
                const appId = 1;
                const key = 1112;
                let data = {
                    area: "",
                    city: "",
                    cooperationType: "",
                    isElite: "",
                    latitude: this.latitude,
                    longitude: this.longitude,
                    pageNum: 1,
                    pageSize: 6,
                    province: this.province,
                    scenicName: "",
                    scenicType: "",
                    productType: 0,
                };
                // 签名生成
                let sign = "appId=" + appId;
                if (data && Object.keys(data).length > 0) {
                    let newKeys = Object.keys(data).sort();
                    newKeys.forEach((key) => {
                        sign += "&" + key + "=" + data[key];
                    });
                }
                sign += key;
                sign = md5Code.md5(sign).toUpperCase();
                data.sign = sign;
                data.appId = appId;
                request({
                    url: "/tour-product/wxscenic/getScenicList",
                    method: "post",
                    data: data,
                })
                    .then(function (res) {
                        if (res.data.code != "200") {
                            throw res.data.msg;
                        }
                        if (res.data.code == "200") {
                            that.scnicDataFrist = res.data.data.list.slice(
                                0,
                                3
                            );
                            that.scnicDataSceond = res.data.data.list.slice(
                                3,
                                6
                            );
                        }
                    })
                    .catch(function (err) {
                        that.$toast(err);
                    });
            } catch (e) {
                console.log(e);
            }
        },
        // 景区距离计算
        distance(dis) {
            let m = "";
            if (dis / 1000 >= 1) {
                m = (dis / 1000).toFixed(2) + "km";
            } else {
                m = dis + "m";
            }
            return m;
        },
        // 查询渠道商
        async priceQuery() {
            const that = this;
            const { channelId, platformSwitch, productId, mode } = this;
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: "加载中",
            });
            await request({
                url:
                    "/tour-product/channel/getCardPrice?productId=" + productId,
                method: "GET",
            })
                .then(function (res) {
                    Toast.clear();
                    // 存在异常
                    if (res.data.code != "200" && res.data.code != "406") {
                        that.$toast(res.data.msg);
                        return;
                    }
                    // 首次访问渠道商不存在，切换至官方渠道询问
                    if (res.data.code == "406" && channelId != 2) {
                        Dialog.confirm({
                            title: "提示",
                            message: "渠道商不存在，是否切换到官方平台购卡？",
                            showCancelButton: false,
                        })
                            .then(() => {
                                that.platformSwitch = true;
                                that.channelId = 2;
                                that.priceQuery();
                            })
                            .catch(() => {});
                        return;
                    }
                    // 首次访问渠道商不存在，成功切换至官方渠道
                    if (
                        res.data.code == "200" &&
                        channelId == 2 &&
                        platformSwitch
                    ) {
                        Cookies.set("productId", productId);
                        Cookies.set("cykskid", channelId);
                        Cookies.set("mode", mode);
                        that.$toast("官方平台切换成功");
                        return;
                    }
                    // 非官网渠道切换（包含首次成功访问非官方渠道和官方渠道）
                    if (res.data.code == "200" && !platformSwitch) {
                        Cookies.set("cykskid", channelId);
                        Cookies.set("productId", productId);
                        Cookies.set("mode", mode);
                        that.price = res.data.data;
                        return;
                    }
                })
                .catch(function (err) {
                    Toast.clear();
                    that.$toast(err);
                });
        },
    },
};
</script>
<style scoped>
html,
body,
#app {
    height: 100%;
    margin: 0;
}
.h100 {
    height: 100px;
}
.container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fff;
}

.content {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 300px;
    left: 0;
    width: 100%;
    height: calc(100% - 170px);
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 背景图层 */
.banner {
    position: relative;
    width: 100%;
    height: 738px;
    background-image: url("../assets/home/bannerBg.png");
    background-size: cover;
    overflow: hidden;
}
.banner .logo {
    position: absolute;
    top: 39px;
    left: 40px;
    z-index: 99;
    width: 248px;
    height: 48px;
    background-image: url("../assets/home/LOGO01.png");
    background-repeat: no-repeat;
    background-size: 248px 48px;
}
.banner .slogan {
    padding-top: 88px;
    text-align: center;
}
.banner .slogan img {
    width: 500px;
}
.banner .card-inner {
    position: absolute;
    bottom: -120px;
    left: 0;
    width: 100%;
}
.banner .card-inner img {
    width: 100%;
}
.banner .card-wrap {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -270px;
}
.banner .card-wrap .card {
    position: relative;
    width: 540px;
}
.banner .card-wrap .card .card-pic {
    width: 100%;
}
.banner .card-wrap .card .card-icon {
    width: 180px;
    position: absolute;
    left: -90px;
    top: -110px;
}
.setMeal {
    display: flex;
    justify-content: space-between;
    margin-top: -50px;
    padding: 0 30px;
    z-index: 99;
}
.setMeal .list {
    position: relative;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    width: calc(50% - 10px);
    background: #fff;
    overflow: hidden;
}
.setMeal .list .title {
    padding: 28px 20px 0 20px;
    width: calc(100% - 40px);
    font-size: 30px;
    font-weight: bold;
    color: #393833;
}
.setMeal .list .subTitle {
    padding: 7px 20px 20px 20px;
    width: calc(100% - 40px);
    font-size: 24px;
    color: #b68508;
}
.setMeal .list .Meal-price {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    background-size: cover;
}
.setMeal .list .Meal-price .type {
    height: 112px;
    line-height: 112px;
    font-size: 28px;
    color: #393833;
}
.setMeal .list .Meal-price .price {
    height: 112px;
    line-height: 112px;
    font-size: 38px;
    color: #393833;
    font-weight: bold;
}
/* 工具栏 */
.service-list {
    padding: 0 32px;
}
.service-list .title {
    padding: 32px 0;
    font-size: 32px;
    font-weight: bold;
}
.tool {
    display: flex;
    justify-content: space-between;
    margin-bottom: 54px;
    padding: 0 30px;
    width: calc(100% - 60px);
}
.tool .list {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 28px;
}
.tool .list .pic {
    position: relative;
    width: 96px;
    height: 96px;
    margin-bottom: 20px;
}
.tool .list .pic .title {
    width: 100%;
    height: 100%;
}
.tool .list .pic .icon {
    position: absolute;
    top: 5px;
    right: -15px;
    width: 70px;
    height: 30px;
}

/* 热门景区一 */
.hotScenic {
    border-top: 20px solid #f7f7f7;
}
.hotScenic .hotTitle {
    padding: 60px 32px 16px;
    background-size: 400px 60px;
}
.hotScenic .hotTitle .txt {
    width: 100%;
    font-size: 32px;
    font-weight: bold;
}
.hotScenic .hotContent {
    padding-bottom: 30px;
}
.scenicTop {
    display: flex;
    justify-content: space-between;
    padding: 0px 30px 0 30px;
    width: calc(100% - 60px);
    height: 420px;
    font-size: 24px;
    color: #fff;
}
.scenicTop .first,
.scenicTop .sceond-thire {
    border-radius: 10px;
    width: calc(50% - 10px);
    height: 420px;
}
.scenicTop .sceond-thire {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.scenicTop .first,
.scenicTop .sceond,
.scenicTop .thire {
    position: relative;
}
.scenicTop .sceond,
.scenicTop .thire {
    width: 100%;
    height: 200px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
    border-radius: 10px;
}
.scenicTop .pic {
    position: relative;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.tag {
    position: absolute;
    left: 0;
    top: 30px;
    background-color: #ffda4d;
    color: #333;
    padding: 0 20px 0 20px;
    height: 36px;
    line-height: 36px;
}
.tag span {
    position: relative;
    display: block;
}
.tag span:after {
    content: "";
    display: block;
    position: absolute;
    right: -32px;
    top: 0px;
    border-right: 12px solid transparent;
    border-top: 18px solid #ffda4d;
    width: 0;
    height: 0;
}
.tag span:after {
    content: "";
    display: block;
    position: absolute;
    right: -32px;
    bottom: 0px;
    border-left: 12px solid transparent;
    border-bottom: 18px solid #ffda4d;
    width: 0;
    height: 0;
}
.scenicTop .name {
    position: absolute;
    bottom: 64px;
    left: 0;
    padding: 0 10px;
    width: calc(100% - 20px);
    font-size: 32px;
    font-weight: bold;
}
.scenicTop .address-distance {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 30px;
    left: 0;
    padding: 0 10px;
    width: calc(100% - 20px);
    font-size: 20px;
}
.scenicTop .address-distance .distance {
    padding-left: 20px;
}

/* 热门景区二 */
.scenicList {
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    margin: 30px auto 0 auto;
    width: calc(100% - 60px);
    height: 260px;
    font-size: 24px;
    overflow: hidden;
}
.scenicList .pic {
    position: relative;
    flex: 0 0 260px;
    width: 260px;
    height: 260px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.scenicList .text {
    display: flex;
    flex-direction: column;
    padding: 0 30px;
    width: calc(100% - 300px);
    height: 260px;
}
.scenicList .name {
    padding-top: 30px;
    font-size: 32px;
    font-weight: bold;
}
.scenicList .address {
    padding-top: 20px;
    height: 90rpx;
    line-height: 45px;
    font-size: 24px;
}
.scenicList .distance {
    padding-top: 20px;
    font-size: 24px;
}
/* logo */
.foot-logo {
    display: block;
    margin: 35px auto;
    width: 280px;
    height: 60px;
}
/* 底部 */
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100;
    padding: 20px 0 50px 0;
    width: 100%;
    height: 100px;
    background-color: #fff;
}

/* 立即购买 */
.payGo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: calc(100% - 60px);
    height: 100px;
    color: #333;
    background-image: url("../assets/home/payGo.png");
    background-size: 100% 100px;
    background-repeat: no-repeat;
    border-radius: 50px;
    box-shadow: 0px 10px 20px 0px rgba(255, 218, 77, 0.6);
}
.payGo .name-price {
    display: flex;
    flex-direction: column;
    padding-left: 50px;
    height: 100%;
}
.payGo .name-price .name {
    height: 40px;
    font-size: 22px;
    line-height: 40px;
    color: #fff;
}
.payGo .name-price .price {
    height: 60px;
    font-size: 40px;
    line-height: 50px;
    color: #ffc539;
}
.payGo .name-price .icon {
    font-size: 32px;
    color: #ffc539;
}
.payGo .pay {
    display: inline-block;
    padding-right: 50px;
    font-size: 36px;
    font-weight: bold;
}
.nowrap-double {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
</style>
